import { ArcadeWheelLandscapeProperties } from "../landscape/ArcadeWheelLandscapeProperties";
/**
 * ArcadeWheelPortraitProperties.ts
 */
export class ArcadeWheelPortraitProperties extends ArcadeWheelLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spinCounterTextProperties.position.set(-169, 340);
        this.instructionsProperties.position.set(495, 498);
        this.qButtonProperties.position.set(250, 184);
        this.scaleNotInProgress.set(0.55);
        this.scaleInProgress.set(0.8);
        this.scaleHidden.set(0.55);
        this.offsetNotInProgress.set(175, 170);
        this.offsetInProgress.set(175, 95);
        this.offsetHidden.set(175, 943);
    }
}
